export class SubscriptionsStore {
    constructor() {
        this.elements = {};
    }
    upsert(element) {
        this.elements[element.t] = element;
    }
    remove(t) {
        delete this.elements[t];
    }
    clear() {
        Object.keys(this.elements).forEach(key => delete this.elements[key]);
    }
    getAll() {
        return Object.values(this.elements);
    }
    get isEmpty() {
        return Object.keys(this.elements).length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/SubscriptionsStore.js